function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _default);

    this.defaults = {
      el: document,
      name: 'scroll',
      "class": 'is-inview',
      offset: 0,
      repeat: false
    };
    Object.assign(this, this.defaults, options);
    this.namespace = 'modular';
    //this.windowHeight = window.innerHeight;
    this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    this.els = [];
    this.scrollPosition = 0;
    this.frame = false;
    this.checkScroll = this.checkScroll.bind(this);
    this.checkResize = this.checkResize.bind(this);
    window.addEventListener('scroll', this.checkScroll, false);
    window.addEventListener('resize', this.checkResize, false);
    this.init();
  }

  _createClass(_default, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.scrollPosition = window.scrollY || window.pageYOffset;
      var els = this.el.querySelectorAll('[data-' + this.name + ']');
      els.forEach(function (el, i) {
        var cl = el.dataset[_this.name + 'Class'] || _this["class"];

        var top = el.getBoundingClientRect().top + _this.scrollPosition;

        var bottom = top + el.offsetHeight;
        var offset = parseInt(el.dataset[_this.name + 'Offset']) || parseInt(_this.offset);
        var repeat = el.dataset[_this.name + 'Repeat'];
        var call = el.dataset[_this.name + 'Call'];

        if (repeat == 'false') {
          repeat = false;
        } else if (repeat != undefined) {
          repeat = true;
        } else {
          repeat = _this.repeat;
        }

        _this.els[i] = {
          el: el,
          "class": cl,
          top: top + offset,
          bottom: bottom,
          offset: offset,
          repeat: repeat,
          inView: false,
          call: call
        };
      });
      this.detectElements();
    }
  }, {
    key: "update",
    value: function update() {
      this.updateElements();
    }
  }, {
    key: "checkScroll",
    value: function checkScroll() {
      var _this2 = this;

      if (this.els.length) {
        this.scrollPosition = window.scrollY || window.pageYOffset;

        if (!this.frame) {
          requestAnimationFrame(function () {
            _this2.detectElements();
          });
          this.frame = true;
        }
      }
    }
  }, {
    key: "checkResize",
    value: function checkResize() {
      var _this3 = this;

      if (this.els.length) {
        //this.windowHeight = window.innerHeight;
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        if (!this.frame) {
          requestAnimationFrame(function () {
            _this3.updateElements();
          });
          this.frame = true;
        }
      }
    }
  }, {
    key: "detectElements",
    value: function detectElements() {
      var _this4 = this;

      var scrollTop = this.scrollPosition;
      var scrollBottom = scrollTop + this.windowHeight;
      this.els.forEach(function (el, i) {
        if (!el.inView) {
          if (scrollBottom > el.top && scrollTop < el.bottom) {
            _this4.setInView(el, i);
          }
        } else {
          if (scrollBottom < el.top || scrollTop > el.bottom) {
            _this4.setOutOfView(el, i);
          }
        }
      });
      this.frame = false;
    }
  }, {
    key: "setInView",
    value: function setInView(el, i) {
      if (el.repeat) {
        this.els[i].inView = true;
      } else {
        this.els.splice(i, 1);
      }

      el.el.classList.add(el["class"]);

      if (el.call) {
        this.callValue = el.call.split(',').map(function (item) {
          return item.trim();
        });
        if (this.callValue.length == 1) this.callValue = this.callValue[0];
        var callEvent = new Event(this.namespace + 'call');
        window.dispatchEvent(callEvent);
      }
    }
  }, {
    key: "setOutOfView",
    value: function setOutOfView(el, i) {
      this.els[i].inView = false;
      el.el.classList.remove(el["class"]);
    }
  }, {
    key: "updateElements",
    value: function updateElements() {
      var _this5 = this;

      this.els.forEach(function (el, i) {
        var top = el.el.getBoundingClientRect().top + _this5.scrollPosition;

        var bottom = top + el.el.offsetHeight;
        _this5.els[i].top = top + el.offset;
        _this5.els[i].bottom = bottom;
      });
      this.frame = false;
    }
  }, {
    key: "on",
    value: function on(event, func) {
      var _this6 = this;

      window.addEventListener(this.namespace + event, function () {
        switch (event) {
          case 'call':
            return func(_this6.callValue);

          default:
            return func();
        }
      }, false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener('scroll', this.checkScroll, false);
      window.removeEventListener('resize', this.checkResize, false);
    }
  }]);

  return _default;
}();

export default _default;
